var carouselConfig = {
  axis: 'x',
  align: 'start',
  containerSelector: '*',
  slidesToScroll: 1,
  containScroll: false,
  draggable: true,
  dragFree: false,
  loop: false,
  speed: 10,
  startIndex: 0,
  selectedClass: 'is-selected',
  draggableClass: 'is-draggable',
  draggingClass: 'is-dragging',
  arrows: true,
  dots: true,
  alignContent: null
};

export { carouselConfig as default };
//# sourceMappingURL=Carousel.config.js.map
